export class VobRequestNotePostCommand{
    verificationId: string;
    vobRequestReason: string;

    constructor(id:string, reason:string){
        this.verificationId = id;
        this.vobRequestReason = reason;
    }
}
